export default __webpack_public_path__ + "static/media/m-icon-gnb-btn-home.0299d20b.svg";